module.exports = __webpack_public_path__ + "img/13-28-164.7a51ede1.jpg";